import React from 'react';
import { useStore } from 'effector-react';
import { queryKeys } from '@queryClient';
import { useTeamConfig } from '@utils/teamConfig';
import { $libSearch } from '../../stores/libState';
import RowMatrix from './RowMatrix';
import MultiplePageFetchList from '../../components/MultiplePageFetchList';
import MultiplePageSearchList from '../../components/MultiplePageSearchList';

const urls = {
  searchUrls: {
    albumUrl: '/member/my/matrix/material/albums/search',
    itemUrl: '/member/my/matrix/materials/search',
  },
  fetchUrls: {
    albumUrl: '/member/my/matrix/material/albums',
    itemUrl: '/member/my/matrix/materials',
  },
};

const teamUrls = {
  searchUrls: {
    albumUrl: '/team/app/tours/matrixes/albums/search',
    itemUrl: '/team/app/tours/matrixes/search',
  },
  fetchUrls: {
    albumUrl: '/team/app/tours/matrixes/albums',
    itemUrl: '/team/app/tours/matrixes',
  },
};

function SceneListMatrix() {
  const query = useStore($libSearch);
  const { searchUrls, fetchUrls } = useTeamConfig(urls, teamUrls);
  return query ? (
    <MultiplePageSearchList
      queryKey={queryKeys.libListMatrix}
      {...searchUrls}
      row={RowMatrix}
    />
  ) : (
    <MultiplePageFetchList
      noNameSort
      queryKey={queryKeys.libListMatrix}
      {...fetchUrls}
      row={RowMatrix}
    />
  );
}

export default SceneListMatrix;
